<template>
  <div>
    <div class="video-container" :style="{ width: size }">
      <div class="widescreen">
        <div class="video">
          <iframe class="content-video"
                  :src="link"
                  ref="video"
                  frameborder="0"
                  sandbox="allow-same-origin allow-scripts"
                  allowfullscreen="allowfullscreen">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PeerTubePlayer } from '@peertube/embed-api'

export default {
  name: 'video-frame',

  components: { PeerTubePlayer },

  props: {
    link: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '100%'
    },
    time: {
      type: Number
    }
  },

  data () {
    return {
      player: Object
    }
  },

  mounted () {
    this.player = new PeerTubePlayer(this.$refs.video)
    if (this.time !== 0) {
      const vm = this
      this.player.ready.then(
        () => vm.player.seek(vm.time)
      )
    }
  },

  watch: {
    time (v) {
      if (this.player == null || !this.player.ready || v === 0) {
        return
      }

      this.player.play()
      this.player.seek(v)
    }
  }
}
</script>

<style>
.video-container {
  position: relative;
  right: 0;
  margin: auto;
}

.widescreen {
  padding-bottom: 56.25%; /* 9/16 = 0.5625 */
}

.video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.content-video {
  width: 100%;
  height: 100%;
}
</style>
